import _ from 'lodash';

//状態から分割ボタンの選択を変更する
export function splitButtonManager() {
  // eslint-disable-next-line no-unused-vars
  var navigationDelegate;
}

splitButtonManager.prototype = {
  init() {
    this.navigationDelegate = [];
  },

  setDelegate(delegate) {
    var _this = this;
    this.navigationDelegate = delegate;
    this.navigationDelegate.observeNavi(function(e, status) {
      _this.updateButton(status);
    });
  },

  updateButton(status) {
    //両方開いてる
    if (status.splitview1 && status.splitview2) {
      _.each(document.querySelectorAll('.sys-splitview-multi'), function(
        button
      ) {
        button.classList.add('selected');
      });
      _.each(document.querySelectorAll('.sys-splitview-single'), function(
        button
      ) {
        button.classList.remove('selected');
      });
    } else {
      _.each(document.querySelectorAll('.sys-splitview-multi'), function(
        button
      ) {
        button.classList.remove('selected');
      });
      _.each(document.querySelectorAll('.sys-splitview-single'), function(
        button
      ) {
        button.classList.add('selected');
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/utilities/splitButtonManager.js